import React, { useState } from 'react';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

interface StripePaymentElementFormProps {
  onSuccess: (paymentIntentId: string) => void;
  onError: (message: string) => void;
  submitLabel?: string;
  disabled?: boolean;
}

const StripePaymentElementForm: React.FC<StripePaymentElementFormProps> = ({
  onSuccess,
  onError,
  submitLabel,
  disabled
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!stripe || !elements) {
      onError("Stripe n'est pas initialisé.");
      return;
    }
    setProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required'
    });

    if (error) {
      const message = error.message || 'Une erreur est survenue.';
      setError(message);
      onError(message);
      setProcessing(false);
      return;
    }

    if (paymentIntent && ['succeeded', 'processing', 'requires_capture'].includes(paymentIntent.status)) {
      setError(null);
      onSuccess(paymentIntent.id);
      setProcessing(false);
      return;
    }

    const fallbackMessage = 'Le paiement n’a pas été confirmé.';
    setError(fallbackMessage);
    onError(fallbackMessage);
    setProcessing(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="p-3 border rounded bg-white">
        <PaymentElement />
      </div>
      {error && <div className="alert alert-danger mt-2">{error}</div>}
      <button
        type="submit"
        className="btn btn-success w-100 mt-3"
        disabled={!stripe || processing || disabled}
      >
        {processing ? 'Traitement...' : (submitLabel || 'Payer par carte')}
      </button>
    </form>
  );
};

export default StripePaymentElementForm;
